import { Box, Button, Paper } from "@mui/material"
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getStoredCompanyDetails, getCompanyDisplayFromDetails, getShortCompanyName } from "../../services/companyService";

function ECRTextFile() {
    const companyDetails = useSelector((state) => state.auth.activeCompanyDetails) || getStoredCompanyDetails();
    const { companyName } = getCompanyDisplayFromDetails(companyDetails || {});

    useEffect(()=>{
        console.log("empDetails");
    })
    const location = useLocation();
    const {empDetails, pfDetail} = location.state;
    let txtData = "";

     /** Company Specific Information */
     const PF_BASIC_LIMIT=pfDetail.PfBasicLimit;
     const PF_PERCENT=pfDetail.PfBasicPer;
 
     const EPS_SALARY_LIMIT=pfDetail.epsSalaryLimit;
     const EPS_PERCENT=pfDetail.epsPercent;
 
     const EDLI_SALARY_LIMIT=pfDetail.edliSalaryLimit;
     const EDLI_PERCENT=pfDetail.edliPercent;

     const empFilteredDetails = empDetails.map((empDetail, index)=>{
        const statutoryEpf = Math.round(empDetail.Gross >= PF_BASIC_LIMIT ? PF_BASIC_LIMIT*PF_PERCENT : empDetail.Gross*PF_PERCENT);
        const statutoryEps = Math.round(empDetail.Gross >= EPS_SALARY_LIMIT ? EPS_SALARY_LIMIT*EPS_PERCENT : empDetail.Gross*EPS_PERCENT);
        const vpfAmount = Math.round(Number(empDetail.VPFAmount) || 0);
        return({
            UAN : empDetail.UANNumber,
            // MEMBER_NAME : empDetail?.full_name ? empDetail?.full_name : `${empDetail?.first_name} ${empDetail?.last_name}` || '',
            MEMBER_NAME : 'NITESH KR',
            GROSS_WAGES : empDetail.Gross,
            EPF_WAGES : PF_BASIC_LIMIT,
            EPS_WAGES : EPS_SALARY_LIMIT,
            EDLI_WAGES : EDLI_SALARY_LIMIT,
            EPF_CONTRI_REMITTED : statutoryEpf + vpfAmount,
            EPS_CONTRI_REMITTED : statutoryEps,
            EPF_EPS_DIFF_REMITTED : statutoryEpf - statutoryEps,
            NCP_DAYS : empDetail.leavesTaken,
            REFUND_OF_ADVANCES : '0',
        })
    });

    txtData += empFilteredDetails.map( (curElem)=>{
        return (
            (curElem.UAN?curElem.UAN:0) + "#~#" 
             + (curElem.MEMBER_NAME?curElem.MEMBER_NAME:0) + "#~#" 
             + (curElem.GROSS_WAGES?curElem.GROSS_WAGES:0) + "#~#" 
             + (curElem.EPF_WAGES?curElem.EPF_WAGES:0) + "#~#" 
             + (curElem.EDLI_WAGES?curElem.EDLI_WAGES:0) + "#~#" 
             + (curElem.EPF_CONTRI_REMITTED?curElem.EPF_CONTRI_REMITTED:0) + "#~#" 
             + (curElem.EPS_CONTRI_REMITTED?curElem.EPS_CONTRI_REMITTED:0) + "#~#" 
             + (curElem.EPF_EPS_DIFF_REMITTED?curElem.EPF_EPS_DIFF_REMITTED:0) + "#~#" 
             + (curElem.NCP_DAYS?curElem.NCP_DAYS:0) + "#~#" 
             + (curElem.REFUND_OF_ADVANCES?curElem.REFUND_OF_ADVANCES:0) + "\n" 
        )
    })
    while(txtData.indexOf(',') != -1) {
        txtData = txtData.replace(',','');
    }
    

    let downloadTxtFile = () => {
        const element = document.createElement("a");
        const file = new Blob([ txtData ], {type: 'text/plain;charset=utf-8'});
        element.href = URL.createObjectURL(file);
        element.download = `${getShortCompanyName(companyName) || 'Report'} Report for ECR.txt`;
        // document.body.appendChild(element);
        element.click();
    }


    return (
        <Box sx={{display: "flex" ,justifyContent: "center", margin: "5x", padding: "20px", fontWeight: "500px"}}>
            <Paper elevation={5} sx={{width: 'min-content', margin: 'auto',padding: '20px'}}>
            <Button 
                variant="contained"
                color = "error"
                onClick={ downloadTxtFile }
            >
                Download ECR Report (Txt)
            </Button>
            <p style={{marginTop: '20px'}}>
                {txtData}
            </p>
            </Paper>
        </Box>
    )
}

export default ECRTextFile